import React from "react";

const Notfound = () => {
    return <div>Error 404 Not found</div>;
};

export default Notfound;
